import React, { useState } from 'react';
import { DropdownMenu, IconButton } from 'library/ui';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useHistory } from 'react-router-dom';

interface IProps {
    options: IOption[];
    onClose?: () => void;
}

interface IOption {
    text: string;
    to?: string;
    onClick?: () => void;
    icon?: React.ReactNode;
}

export const Options = ({ options, onClose }: IProps) => {
    const [open, setOpen] = useState(false);
    const history = useHistory();

    const handleClick = () => {
        setOpen(!open);
    };
    function closeOnNavigation() {
        setOpen(false);
        onClose?.();
    }

    return (
        <DropdownMenu
            trigger={
                <IconButton icon={MoreVertIcon} onClick={handleClick} size={26} iconSize={16} tooltip="More options" />
            }
            open={open}
            onClose={() => setOpen(false)}
            items={options.map((option) => ({
                label: option.text,
                icon: option.icon,
                onClick: () => {
                    if (option.to) history.push(option.to);
                    else option?.onClick?.();
                    closeOnNavigation();
                },
            }))}
        />
    );
};
